<p class="label"><ng-content select="label"></ng-content></p>

<div class="content">
    <ng-content></ng-content>
</div>
